import { Card, CardBody } from 'components/card';
import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import FormEditHeaderButtons from 'containers/partials/buttons/FormEditHeaderButtons';
import FormEditFooterButtons from 'containers/partials/buttons/FormEditFooterButtons';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import IllnessForm from 'containers/pages/rehab/illness/IllnessForm';
import IllnessDetailFields from 'containers/pages/rehab/illness/IllnessDetailFields';
import useEdit from 'hooks/utils/useEdit';
import RemovePersonIllnessButton from 'containers/partials/buttons/RemoveIllnessButton';
import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { StoreContext } from 'index';
import { useContextMenu } from 'contexts/ContextMenuProvider';

function IllnessDetailsTab({ personIllness, medical, ...props }) {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { entityId, groupId, personId, illnessId } = useParams();
  const [edit, setEdit] = useEdit(props.edit, true);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextMenuItems = [];
    if (user.canRemovePersonInjury(entityId)) {
      contextMenuItems.push(
        <RemovePersonIllnessBtn key="remove-person-illness-btn" />
      );
    }
    setMenuItems(contextMenuItems);
    return () => clearAllContext();
  }, [entityId]);

  const RemovePersonIllnessBtn = () => (
    <RemovePersonIllnessButton
      menu
      entityId={entityId}
      groupId={groupId}
      personId={personId}
      personIllnessId={illnessId}
    >
      <FormattedMessage {...messages.rehabMenuItemRemovePersonIllness} />
    </RemovePersonIllnessButton>
  );

  return (
    <Card secondary>
      <IllnessForm
        entityId={entityId}
        personId={personId}
        personIllness={personIllness}
        medical={medical}
      >
        {({ submitForm, resetForm }) => (
          <>
            <CardHeader secondary>
              <CardHeaderTitle>
                <FormattedMessage {...messages.titleIllnessDetails} />
              </CardHeaderTitle>
              <FormEditHeaderButtons
                edit={edit}
                setEdit={setEdit}
                onCancel={resetForm}
                onSubmit={submitForm}
                type={'button'}
              />
            </CardHeader>
            <CardBody secondary>
              <IllnessDetailFields edit={edit} />
            </CardBody>
            <FormEditFooterButtons
              edit={edit}
              setEdit={setEdit}
              onCancel={resetForm}
              onSubmit={submitForm}
              type={'button'}
            />
          </>
        )}
      </IllnessForm>
    </Card>
  );
}

export default IllnessDetailsTab;
